import { render } from "./PriceBar.vue?vue&type=template&id=4e9085dd&scoped=true"
import script from "./PriceBar.vue?vue&type=script&lang=js"
export * from "./PriceBar.vue?vue&type=script&lang=js"

import "./PriceBar.vue?vue&type=style&index=0&id=4e9085dd&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9085dd"]])

export default __exports__